import { useStoreMetalIso } from '@core/context';
import { EMetal } from '@core/type';
import { HookStoreFn, MetalIsoHook, MetalIsoState } from '@core/type/context';

export const useMetalIso: HookStoreFn<MetalIsoState, MetalIsoHook> = () => {
  const [metalIso, setMetalIso] = useStoreMetalIso<EMetal>('metalIso');

  return { metalIso, setMetalIso };
};
